import MotionWrapper from '../../../containers/MotionWrapper';
import LegalContainer from '../../../containers/Legal';
import styles from './style.module.scss';
import Modal from '../../../components/Modal';
import { TypographyLogo } from '../../../assets/icons/common';
import { useEffect, useState } from 'react';

const appVersion = process.env.REACT_APP_VERSION;

export default function Legal() {
    const [versionModalOpen, setVersionModalOpen] = useState(false);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (!e.shiftKey || e.key.toLowerCase() !== 'q') return;

            e.preventDefault();
            setVersionModalOpen(true);
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    return (
        <MotionWrapper className={styles.container}>
            <LegalContainer />

            {versionModalOpen && (
                <Modal
                    size='sm'
                    childClassName={styles.version_modal}
                    closeFunc={() => setVersionModalOpen(false)}
                >
                    <TypographyLogo width={200} height={52} />
                    <span className={styles.version_modal_text}>
                        All rights reserved.&copy; {new Date().getFullYear()} MeritFinder, Inc.
                        <br />
                        V <code>{appVersion}</code>
                    </span>
                </Modal>)}
        </MotionWrapper>
    );
};
